import {getWeekNumber} from '@lib/utils';
import {Dictionary} from '@reduxjs/toolkit';
import {CalendarDay, CalendarWeek} from '../../../data/calendar/types';
import {UICalendarWeek, UICalendarWeekType} from '../types';
import {toUICalendarDays} from './uiCalendarDayMapper';

const lookupCalendarDay = (daysByWeekNumber: Dictionary<CalendarDay>) => (day: string) => daysByWeekNumber[day];

export const getWeekType = (weekNumber: number, thisWeekNumber: number): UICalendarWeekType => {
  return weekNumber === thisWeekNumber ? 'thisWeek' : weekNumber === thisWeekNumber + 1 ? 'nextWeek' : 'futureWeek';
};

export const toUICalendarWeek =
  (daysByWeekNumber: Dictionary<CalendarDay>, today: string) =>
  ({days, weekNumber}: CalendarWeek): UICalendarWeek => {
    const thisWeekNumber = getWeekNumber(today);

    return {
      data: toUICalendarDays(days.map(lookupCalendarDay(daysByWeekNumber)), today),
      weekNumber,
      weekType: getWeekType(weekNumber, thisWeekNumber),
    };
  };

export const toUICalendarWeeks = (weeks: CalendarWeek[], daysByWeekNumber: Dictionary<CalendarDay>, today: string) =>
  weeks.map(toUICalendarWeek(daysByWeekNumber, today));
